@if (title()) {
<div class="section-header">
  <h3 translate>
    {{ title() }}
    <ng-content select="[section-title]"></ng-content>
  </h3>
  <small class="text-muted section-subtitle" translate>
    {{ subtitle() }}
    <ng-content select="[section-subtitle]"></ng-content>
  </small>
  <ng-content select="[section-subtitle-postfix]"></ng-content>
</div>
} @if (!title()) {
<div class="section-header section-header-dummy"></div>
}
<div class="section-body">
  <ng-content></ng-content>
</div>
